import { IApiError } from '@/models/apiError.model';
import { showErrorToast } from '@/components';

const toToastMessage = (value: unknown, fallback: string): string => {
  if (typeof value === 'string' && value.trim()) return value;
  if (
    value &&
    typeof value === 'object' &&
    'message' in value &&
    typeof (value as { message: unknown }).message === 'string'
  ) {
    return (value as { message: string }).message;
  }
  return fallback;
};

const showApiErrors = (err: unknown) => {
  if (err == null || typeof err !== 'object') {
    showErrorToast({ message: 'Error' });
    return;
  }

  const { message: rawMessage, errors } = err as IApiError;
  const message = typeof rawMessage === 'string' && rawMessage.trim() ? rawMessage : 'Error';

  if (errors && typeof errors === 'object') {
    const fieldMessages = Object.values(errors);
    if (fieldMessages.length) {
      fieldMessages.forEach((value) => {
        showErrorToast({ message: toToastMessage(value, message) });
      });
      return;
    }
  }

  showErrorToast({ message });
};

export default showApiErrors;
